import React from 'react'
import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import { ReactComponent as Shape1 } from '../../assets/svg/contact-shape.svg'
import { TABLET } from '../../lib/constant'

export default function ContactBanner() {
	return (
		<Section>
			<Content>
				<Text>
					<h1>문의하기</h1>
					<h2>궁금한 점이나 제휴 문의에 대해 문의해주세요.</h2>
				</Text>
				<Shapes>
					<Shape1 className="shape" />
				</Shapes>
			</Content>
		</Section>
	)
}

const Section = styled.section`
	height: 360px;
	width: 100%;
	background-color: #fafafa;
	overflow: hidden;
	${down(TABLET)} {
		height: 255px;
	}
`

const Content = styled.div`
	max-width: 1440px;
	height: 100%;
	margin: 0 auto;
	position: relative;
`

const Text = styled.div`
	display: flex;
	flex-direction: column;
	width: 55%;
	margin-left: auto;
	padding-top: 150px;
	position: relative;
	z-index: 1;

	> h1 {
		font-size: 72px;
		line-height: 80px;
		color: #131313;
		font-weight: 700;
		letter-spacing: -0.02em;
	}

	> h2 {
		font-size: 24px;
		line-height: 28px;
		color: #131313;
		margin-top: 32px;
		letter-spacing: -0.02em;
	}

	${down(TABLET)} {
		width: 100%;
		padding: 16px;
		justify-content: flex-end;
		height: 100%;
		> h1 {
			font-size: 48px;
			line-height: 56px;
		}

		> h2 {
			font-size: 18px;
			line-height: 24px;
			margin-top: 8px;
		}
	}
`

const Shapes = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;

	> * {
		position: absolute;
		&.shape {
			top: 0;
			left: 150px;
		}

		${down(TABLET)} {
			width: 100%;
			&.shape {
				top: 0;
				left: 112px;
			}
		}
	}
`
